import addIcon from '../assets/icons/add_icon.png'
import bgImage from '../assets/icons/appointment_crd.png'
import nextIcon from '../assets/icons/next_icon.png'

function TechnicianPreview({iconUrl, logoUrl, font}) {


    return(
        <div className={`flex justify-center text-${font.fontSize}`} style={{ fontFamily: font.fontFamily}}>
            <div className="w-1/3">
                <div className='py-4'>
                    <span className="text-xl font-semibold py-1">Appointments for today</span>
                </div>

                <div className='bg-customTwo rounded-xl p-4 text-center'>
                <div>
                    <img src={bgImage} />
                </div>
                {
                    <div>
                        <div className='py-4 flex justify-between'>
                            <div className={"text-md font-semibold py-1"}>{`Kunal Kamal`}</div>
                            <div className={'text-sm py-1 font-semibold text-customOne cursor-pointer'} >{`Manage Appointment >`}</div>
                        </div>
                        <div className='flex gap-1'>
                            <div className='flex items-center'>
                                <img src={nextIcon} className='rotate-180 cursor-pointer'/>
                            </div>
                            <div className='bg-white p-4 rounded-md flex-1' >
                                <div className='flex justify-between py-2'>
                                    <div className={"text-sm py-1 font-semibold"}>Vehicle</div>
                                    <div className={"text-sm py-1"}>Ford</div>
                                </div>
                                <div className='flex justify-between py-2'>
                                    <div className={"text-sm py-1 font-semibold"}>Date</div>
                                    <div className={"text-sm py-1"}>2024-12-20</div>
                                </div>
                                <div className='flex justify-between py-2'>
                                    <div className={"text-sm py-1 font-semibold"}>Time</div>
                                    <div className={"text-sm py-1"}>8:00 AM - 11:00 AM</div>
                                </div>
                            </div>
                            <div className='flex items-center'>
                                <img src={nextIcon} className='cursor-pointer' />
                            </div>
                        </div>
                    </div>
                }
            </div>  
                
                <div className='py-4'>
                    <span className="text-xl font-semibold py-1">Equipment Available</span>
                </div>
                <div className='bg-customTwo rounded-xl p-4 text-center'>
                    <div>
                        <img src={bgImage} />
                    </div>
                    
                    <div>
                        <div className='py-4 flex justify-between'>
                            <div className={"text-md font-semibold py-1"}>{'Kunal Kamal'}</div>
                            <div className={'text-sm py-1 font-semibold text-customOne cursor-pointer'}>{`Manage Equipment >`}</div>
                        </div>
                        <div className='flex gap-1'>
                            <div className='flex items-center'>
                                <img src={nextIcon} className='rotate-180 cursor-pointer' />
                            </div>
                            <div className='bg-white p-4 rounded-md flex-1'>
                                <div className='flex justify-between py-2'>
                                    <div className={"text-sm py-1 font-semibold"}>Date</div>
                                    <div className={"text-sm py-1"}>2024-12-20</div>
                                </div>
                                <div className='flex justify-between py-2'>
                                    <div className={"text-sm py-1 font-semibold"}>Check-In Time</div>
                                    <div className={"text-sm py-1"}>11:45:00 </div>
                                </div>
                                <div className='flex justify-between py-2'>
                                    <div className={"text-sm py-1 font-semibold"}>Check-Out Time</div>
                                    <div className={"text-sm py-1"}>14:45:00</div>
                                </div>
                            </div>
                            <div className='flex items-center'>
                                <img src={nextIcon} className='cursor-pointer' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex justify-center items-center p-4 rounded-lg border-2 border-dashed border-customOne mt-4'>
                    <img src={addIcon} />
                </div>
            </div>
        </div>
    )
}

export default TechnicianPreview;